import React from 'react';

export default ({v, type, children, w="50px", ...props}) => {
  let style = props.style || {};
  style.width = w;
  return <div className={`score-tag ${type}-tag ${props.onClick && "cursor-pointer"}`} {...props} style={style}>{children || v}</div>;
}


